import React from 'react';

import { cn } from '@epoch-ui/lib/utils';
import { Input, InputProps } from '@epoch-ui/components/Input';

export const TitleInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <Input
        className={cn(
          'tw-rounded-none tw-h-12 tw-border-0 tw-border-solid tw-border-medium-grey tw-px-1 tw-py-0 tw-text-4xl tw-font-bold placeholder:tw-text-card-foreground/20 focus-visible:tw-border-medium-grey',
          error && 'tw-text-negative-foreground placeholder:tw-text-negative-foreground',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
